import React from 'react'
import { Link } from 'react-router-dom'
import './legaldisclaimer.scss'

const LegalDisclaimerContent = () => {
  return (
    <div className='legal-content'>
        <div className='common-heading'>
            <h2>The following information focuses on our Sentry Group of Companies and associated legal information.</h2>
        </div>
        <div className='content'>
            <p>The Sentry Group of Companies Includes:</p>
            <ul>
                <li>Sentry Insurance Company</li>
                <li>Dairyland County Mutual Insurance Company of Texas</li>
                <li>Dairyland Insurance Company</li>
                <li>Dairyland National Insurance Company</li>
                <li>Florists’ Insurance Company</li>
                <li>Florists’ Insurance Company</li>
                <li>Middlesex Insurance Company</li>
                <li>Parker Centennial Assurance Company</li>
            </ul>
            <p>Property and casualty coverages are underwritten and safety services are provided by a member of the Sentry Insurance Group, Stevens Point, WI. Life insurance and annuities are issued and administered by Sentry Life Insurance Company, Stevens Point, WI. In New York, life insurance and annuities are issued and administered by Sentry Life Insurance Company of New York, Syracuse, NY and are not available in all states. For a complete listing of companies, visit sentry.com. Policies, coverages, benefits, and discounts are not available in all states. See policy for complete coverage details: (Life Insurance) 390-1035(SLONY), 390-2003-SLONY; (Group Annuity) 840-300(NY); (Individual Annuity) 380-440.</p>
            <h3>Legal Disclaimer</h3>

            <p>This website is for convenience and information purposes only, and is made available by Sentry Insurance Company and its subsidiaries and affiliates with the understanding that Sentry is not engaged in the practice of law, nor is it rendering legal, tax, accounting, investment, or financial advice. The information contained in this website is of a general nature and is not intended to address the circumstances of any particular individual or entity. No one should act on the information contained in this website without legal/financial advice from competent and licensed local professionals. THE INFORMATION CONTAINED IN THIS WEBSITE IS DISTRIBUTED BY SENTRY “AS-IS,”
                 WITHOUT ANY WARRANTIES. SENTRY’S LIABILITY IS LIMITED AS SET FORTH ON THIS WEBSITE’S <Link to="/terms-and-conditions">TERMS AND CONDITIONS</Link> PAGE.</p>
        </div>
    </div>
  )
}

export default LegalDisclaimerContent
